import type { ResourceMap } from '../../resources/types';
import { InventoryItem } from '../../resources/types';
import type { PurchasesList } from '../../../libs/offerSystem/OfferSystemHistory';
import { calculateSpendingBand } from '../../iap/calculateSpendingBand';
import type { StateProxy } from '../offersTypes';

export class DebugOfferState implements StateProxy {
  private tier1 = true;

  public isTier1(): boolean {
      return this.tier1;
  }

  private inSeasonPass = true;

  public isInSeasonPassWithoutPremium(): boolean {
      return this.inSeasonPass;
  }

  private level = 1;

  private readonly inventory: ResourceMap = {
    [InventoryItem.Coin]: 0,
    [InventoryItem.BoosterHammer]: 0,
    [InventoryItem.BoosterMove]: 0,
    [InventoryItem.BoosterRedraw]: 0,
  };

  private currentTime = Date.now();

  private createDate = Date.now();

  private band = 0;

  public getLevelNumber(): number {
    return this.level;
  }

  public getInventory(): ResourceMap {
    return this.inventory;
  }

  public getCurrentTime(): number {
    return this.currentTime;
  }

  public getUserCreateDate(): number {
    return this.createDate;
  }

  public getBand(history: PurchasesList): number {
    this.band = calculateSpendingBand(history);
    return this.band;
  }

  public getLastBand(): number {
    return this.band;
  }

  public setLevelNumber(value: number): void {
    this.level = value;
  }

  public setCurrentTime(value: number): void {
    this.currentTime = value;
  }

  public setUserCreateDate(value: number): void {
    this.createDate = value;
  }

  public setSeasonPass(value: boolean): void {
    this.inSeasonPass = value;
  }

  public setTier1(value: boolean): void {
    this.tier1 = value;
  }

  public setBand(value: number): void {
    this.band = value;
  }
}
